var map = {
	"./bg0.jpg": [
		6994,
		994
	],
	"./bg1.jpg": [
		5049,
		49
	],
	"./bg2.jpg": [
		3074,
		74
	],
	"./bg3.jpg": [
		4507,
		507
	],
	"./bg4.jpg": [
		8280,
		280
	],
	"./bg5.jpg": [
		3577,
		577
	],
	"./bg6.jpg": [
		9654,
		654
	],
	"./bg7.jpg": [
		8958,
		958
	],
	"./bg8.jpg": [
		3445,
		445
	],
	"./bg9.jpg": [
		4781,
		781
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => Object.keys(map);
webpackAsyncContext.id = 7580;
module.exports = webpackAsyncContext;